export default "__VITE_ASSET__lAyv71UQ__"